import React, { useEffect, useState } from 'react';
import useOnlineStatus from '../../hooks/UseOnlineStatus';
// import { toast } from "react-toastify";
import Spinner from '../spinner';


const NetworkStatus = () => {
  const  { isOnline, wasOnline, setWasOnline } = useOnlineStatus();
  const [isYoureBackOnline, setIsYoureBackOnline] = useState(true);

  useEffect(() => {
    if (isOnline && !wasOnline) {
    //   toast.success("You're back online!",

    //    );
      setWasOnline(true);
      setTimeout(() => {
        setIsYoureBackOnline(false);
      }, 10000);
    } else if (!isOnline && wasOnline) {
    //   toast.error("You're offline");
      setWasOnline(false);
    }
  }, [isOnline, wasOnline, setWasOnline]);

  return (
    <div className=' position-absolute end-0 px-4 py-2 ' style={{top: '50px', }}>
      {(isOnline && isYoureBackOnline) ? (
        <p className=' rounded-2 p-2 bg-secondary text-white '>You're back online!</p>
      ) : !isOnline && (
        <p className=' rounded-1 p-2 bg-danger text-white '> <Spinner color='' /> Internet connection lost.</p>
      )}
    </div>
  );
};

export default NetworkStatus;
